export default __webpack_public_path__ + "static/media/user-plus.ce4a520f.svg";